
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sklep/teneryfa",
      function () {
        return require("private-next-pages/sklep/teneryfa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sklep/teneryfa"])
      });
    }
  